import { documentEvents } from '@elab/core/utils/eventConstants';
import MyAccountNavigation from '@elab/components/connected/my-account/MyAccountNavigation';
import MyAccountLogout from '@elab/components/connected/my-account/MyAccountNavigationLogout';
import MyAccountNavigationLink from '@elab/components/connected/my-account/MyAccountNavigationLink';
import MyAccountNavigationGroup from '@elab/components/connected/my-account/MyAccountNavigationGroup';
import GiftCard from '@elab/components/connected/forms/GiftCardDynamicForm/GiftCard';
import GiftCardsCarousel from '@elab/components/connected/forms/GiftCardDynamicForm/GiftCardsCarousel';
import EmailGiftCardResendForm from '@elab/components/connected/forms/EmailGiftCardResendForm';
import AddressSuggestionsList from '@elab/components/connected/forms/AddressSuggestionsList';
import VouchersList from '@elab/components/connected/forms/GiftCardDynamicForm/VouchersList';
import NavigationConfirm from '@elab/components/Navigation//NavigationConfirm';
import NestedTabs from '@elab/components/common/NestedTabs';
import OrderHistoryOrderNumber from '@elab/components/connected/OrderHistoryOrderNumber';
import LoadMore from '@elab/components/connected/LoadMore';
import ProductSummaryGrid from '@elab/components/connected/cart/ProductSummaryGrid';
import PickStore from '@elab/components/connected/PickStore';
import PSPiframe from '@elab/components/connected/PSPiframe';
import Wishlist from '@elab/components/connected/wishlist/Wishlist';
import WishlistProductInfo from '@elab/components/connected/wishlist/WishlistProductInfo';
import WishlistProductPromotion from '@elab/components/connected/wishlist/WishlistProductPromotion';
import WishlistProductQuantity from '@elab/components/connected/wishlist/WishlistProductQuantity';
import WishlistAddToCart from '@elab/components/connected/wishlist/WishlistAddToCart';
import WishlistRemoveProduct from '@elab/components/connected/wishlist/WishlistRemoveProduct';
import WishlistQuantitySelect from '@elab/components/connected/wishlist/WishlistQuantitySelect';
import WishlistGridLayout from '@elab/components/connected/wishlist/WishlistGridLayout';
import StoreDetailsAddress from '@elab/components/connected/store-details/StoreDetailsAddress';
import StoreDetailsPhone from '@elab/components/connected/store-details/StoreDetailsPhone';
import StoreDetailsHours from '@elab/components/connected/store-details/StoreDetailsHours';
import CartSummary from '@elab/components/connected/cart/CartSummary';
import GiftCustomizationList from '@elab/components/connected/giftWrap/GiftCustomizationList';
import GiftOptionMessage from '@elab/components/connected/giftWrap/GiftOptionMessage';
import WizardNext from '@elab/components/connected/forms/WizardNext';
import WizardPrev from '@elab/components/connected/forms/WizardPrev';
import WizardReset from '@elab/components/connected/forms/WizardReset';
import FieldError from '@elab/components/connected/forms/FieldError';
import FieldRefError from '@elab/components/connected/forms/FieldRefError';
import FieldCaption from '@elab/components/connected/forms/FieldCaption';
import CustomSelect from '@elab/components/connected/fields/CustomSelect';
import DeliveryAddress from '@elab/components/connected/DeliveryAddress';
import PaymentAddress from '@elab/components/connected/PaymentAddress';
import UserAddress from '@elab/components/connected/UserAddress';
import NestedForm from '@elab/components/connected/forms/NestedForm';
import DatepickerCalendar from '@elab/components/connected/forms/DatepickerCalendar';
import StaticDatePickerField from '@elab/components/connected/forms/StaticDatePickerField';
import SelectField from '@elab/components/connected/fields/SelectField';
import SearchSelectField from '@elab/components/connected/fields/SearchSelectField';
import DeliveryGroup from '@elab/components/connected/DeliveryModes/DeliveryGroup';
import QuantitySelect from '@elab/components/connected/fields/QuantitySelect';
import Breadcrumbs from '@elab/components/connected/Breadcrumbs';
import BreadCrumbsItem from '@elab/components/connected/BreadCrumbsItem';
import RegistrationForm from '@elab/components/connected/forms/RegistrationForm';
import LoyaltyCardHistory from '@elab/components/connected/loyaltyCardHistory';
import PrivacyPreferencesForm from '@elab/components/connected/forms/PrivacyPreferencesForm';
import LoyaltySummary from '@elab/components/connected/cart/LoyaltySummary';
import Barcode from '@elab/components/connected/Barcode';
import CheckoutForm from '@elab/components/connected/forms/CheckoutForms';
import CheckoutAddressForm from '@elab/components/connected/forms/CheckoutAddressForms';
import PaymentActionButton from '@elab/components/connected/PaymentActionButton';
import PaymentPriceInformation from '@elab/components/connected/PaymentPriceInformation';
import GoogleMap from '@elab/components/connected/store-locator/GoogleMap';
import StoreInfoWindow from '@elab/components/connected/store-locator/StoreInfoWindow';
import StoreLocatorSelectableList from '@elab/components/connected/StoreLocatorSelectableList';
import PersonalInformationForm from '@elab/components/connected/forms/PersonalInformationForm';
import PaymentMethods from '@elab/components/connected/PaymentMethods';
import PaymentMethodSOP from '@elab/components/connected/PaymentMethodSOP';
import OrderDeliveryAddress from '@elab/components/connected/order/OrderDeliveryAddress';
import StoreAlphabet from '@elab/components/connected/store-locator/StoreAlphabet';
import StoreAlphabetCarousel from '@elab/components/connected/store-locator/StoreAlphabetCarousel';
import StoreAlphabetLetterGroup from '@elab/components/connected/store-locator/StoreAlphabetLetterGroup';
import RemoveCardDialog from '@elab/components/connected/my-account/RemoveCardDialog';
import LoyaltyOptionsForm from '@elab/components/connected/forms/LoyaltyOptionsForm';
import OrderSummaryGiftCards from '@elab/components/connected/order/OrderSummaryGiftCards';
import CartSummaryPromotions from '@elab/components/connected/cart/CartSummaryPromotions';
import OrderSummaryPromotions from '@elab/components/connected/order/OrderSummaryPromotions';
import CartSummaryGiftOptions from '@elab/components/connected/cart/CartSummaryGiftOptions';
import OrderSummaryGiftOptions from '@elab/components/connected/order/OrderSummaryGiftOptions';
import OrderPaymentAddress from '@elab/components/connected/order/OrderPaymentAddress';
import HiddenInputField from '@elab/components/connected/forms/HiddenInputField';
import FiltersAccordion from '@elab/components/connected/FiltersAccordion';
import PreventClick from '@elab/components/connected/PreventClick';
import OrderProductSummaryGrid from '@elab/components/connected/order/OrderProductSummaryGrid';
import OutOfStockProducts from '@elab/components/connected/cart/OutOfStockProducts';
import AddressBook from '@elab/components/connected/AddressBook';
import TimePicker from '@elab/components/connected/forms/TimePicker';
import DateContent from '@elab/components/connected/DateContent';
import WishlistEgiftCardInfo from '@elab/components/connected/wishlist/WishlistEgiftCardInfo';
import WhenContain from '@elab/components/connected/WhenContain';
import ShippingCountdown from '@elab/components/connected/ShippingCountdown';
import Loading from '@elab/components/connected/Loading';
import GlobalMessage from '@elab/components/connected/global-message/GlobalMessage';
import StoreCountdown from '@elab/components/connected/StoreCountdown';
import LoyaltyCardForm from '@elab/components/connected/forms/LoyaltyCardForm';
import PasswordField from '@elab/components/connected/forms/PasswordField';
import ProductInfo from '@elab/components/connected/cart/ProductInfo';
import ResetPasswordForm from '@elab/components/connected/forms/ResetPasswordForm';
import ForgotPasswordForm from '@elab/components/connected/forms/ForgotPasswordForm';
import PinCodeForm from '@elab/components/connected/forms/PinCodeForm';
import SocialForm from '@elab/components/connected/SocialForm';
import SocialLogin from '@elab/components/connected/SocialLogin';
import PrivacyDialog from '@elab/components/connected/PrivacyDialog';
import NewsletterSubscriptionForm from '@elab/components/connected/forms/NewsletterSubscriptionForm';
import EmailGiftCardForm from '@elab/components/connected/forms/EmailGiftCardForm';
import MyBillingAddress from '@elab/components/connected/MyAddresses/MyBillingAddress';
import MyShippingAddress from '@elab/components/connected/MyAddresses/MyShippingAddress';
import ChangeEmailForm from '@elab/components/connected/forms/ChangeEmailForm';
import ChangePasswordForm from '@elab/components/connected/forms/ChangePasswordForm';
import IsVisible from '@elab/components/connected/IsVisible';

import ProductSummaryRowLayout from './components/connected/cart/ProductSummaryRowLayout';
import WishlistRowLayout from './components/connected/wishlist/WishlistRowLayout';
import OrderDisplayStores from './components/connected/order/OrderDisplayStores';
import DisplayStores from './components/connected/store-locator/shop/DisplayStores';
import PurchaseAnalyticsTracker from './components/connected/order/PurchaseAnalyticsTracker';
import PaymentIFrame from './components/connected/payment/PaymentIFrame';
import CartPhoneNumber from './components/connected/cart/PhoneNumber';
import ContactUsOrderSelection from './components/connected/contact-us/contactUsOrderSelection';
import ContactUsSelect from './components/connected/contact-us/contactUsSelect';
import LoyaltyCardScanner from './components/connected/my-account/LoyaltyCardScanner';
import OrderHistoryGrid from './components/connected/OrderHistoryGrid';
import MyAccountPaymentCards from './components/connected/my-account/MyAccountPaymentCards';
import OutOfMaxAllowedProducts from './components/connected/cart/OutOfMaxAllowedProducts';

if (!window.e2_not_common_initilized) {
    const notCommonComponents = [
        EmailGiftCardForm,
        NewsletterSubscriptionForm,
        PrivacyDialog,
        SocialLogin,
        SocialForm,
        PinCodeForm,
        ForgotPasswordForm,
        ResetPasswordForm,
        ProductInfo,
        PasswordField,
        LoyaltyCardForm,
        MyAccountNavigation,
        MyAccountLogout,
        MyAccountNavigationLink,
        MyAccountNavigationGroup,
        GiftCard,
        GiftCardsCarousel,
        EmailGiftCardResendForm,
        AddressSuggestionsList,
        VouchersList,
        NavigationConfirm,
        NestedTabs,
        OrderHistoryGrid,
        OrderHistoryOrderNumber,
        LoadMore,
        ProductSummaryGrid,
        CartPhoneNumber,
        ProductSummaryRowLayout,
        PickStore,
        PSPiframe,
        Wishlist,
        WishlistProductInfo,
        WishlistProductPromotion,
        WishlistProductQuantity,
        WishlistAddToCart,
        WishlistRemoveProduct,
        WishlistQuantitySelect,
        StoreDetailsAddress,
        StoreDetailsPhone,
        StoreDetailsHours,
        CartSummary,
        GiftCustomizationList,
        GiftOptionMessage,
        WizardNext,
        WizardPrev,
        WizardReset,
        FieldError,
        FieldRefError,
        FieldCaption,
        CustomSelect,
        DeliveryAddress,
        PaymentAddress,
        UserAddress,
        NestedForm,
        DatepickerCalendar,
        StaticDatePickerField,
        SelectField,
        SearchSelectField,
        DeliveryGroup,
        QuantitySelect,
        Breadcrumbs,
        BreadCrumbsItem,
        RegistrationForm,
        LoyaltyCardHistory,
        PrivacyPreferencesForm,
        LoyaltySummary,
        Barcode,
        CheckoutForm,
        CheckoutAddressForm,
        PaymentActionButton,
        PaymentPriceInformation,
        GoogleMap,
        StoreInfoWindow,
        StoreLocatorSelectableList,
        PersonalInformationForm,
        PaymentMethods,
        PaymentMethodSOP,
        OrderDeliveryAddress,
        StoreAlphabet,
        StoreAlphabetCarousel,
        StoreAlphabetLetterGroup,
        MyAccountPaymentCards,
        RemoveCardDialog,
        LoyaltyOptionsForm,
        OrderSummaryGiftCards,
        CartSummaryPromotions,
        OrderSummaryPromotions,
        CartSummaryGiftOptions,
        OrderSummaryGiftOptions,
        OrderPaymentAddress,
        HiddenInputField,
        FiltersAccordion,
        PreventClick,
        OrderProductSummaryGrid,
        OutOfStockProducts,
        AddressBook,
        TimePicker,
        DateContent,
        WishlistEgiftCardInfo,
        WhenContain,
        ShippingCountdown,
        WishlistRowLayout,
        WishlistGridLayout,
        OrderDisplayStores,
        DisplayStores,
        PurchaseAnalyticsTracker,
        Loading,
        GlobalMessage,
        StoreCountdown,
        PaymentIFrame,
        ContactUsOrderSelection,
        ContactUsSelect,
        MyBillingAddress,
        MyShippingAddress,
        ChangeEmailForm,
        ChangePasswordForm,
        LoyaltyCardScanner,
        IsVisible,
        OutOfMaxAllowedProducts,
    ];

    const loaders = notCommonComponents.map(comp => {
        return new Promise(res => setTimeout(res, 0)).then(comp);
    });
    Promise.all(loaders).then(() => {
        document.dispatchEvent(new Event(documentEvents.NOT_COMMON_COMPONENTS_READY));
    });
    window.e2_not_common_initilized = true;
}
